<!--
 * @Description: 报名成功信息页
 * @Author: 山淑兰
 * @Date: 2019-11-11 17:39:20
 * @LastEditTime: 2020-07-15 18:03:43
 * @LastEditors: 山淑兰
 -->
<template>
	<div id="signUpInfo">
		<Loading v-if="show"></Loading>
		<div class="signUpInfo_container" v-else>
			<div class="signUpInfo_content">
				<div class="signUpInfo-banner" v-if="bannerList.length>0">
					<swiper :options="swiperOption">
						<swiper-slide class="swiper-slide">
							<img :src="MeetingBasic.MobileBannerImage" alt />
						</swiper-slide>
						<swiper-slide class="swiper-slide" v-for="(item,index) in bannerList" :key='index'>
							<a :href="item.AdUrl"><img :src="item.AdPath" alt /></a>
						</swiper-slide>
						<div class="swiper-pagination" slot="pagination"></div>
					</swiper>
				</div>
				<div class="signUpInfo-banners" v-else>
					<img :src="MeetingBasic.MobileBannerImage" alt />
				</div>
				<div id="meeting_info" class="commonW" v-if="datas.Code">
					<div class="meetingInfo_img">
						<img :src="MeetingBasic.MeetingLogo" alt />
					</div>
					<div class="meetingInfo_content">
						<ul class="meetingInfo_content_lists">
							<li class="meetingInfo_lists_item">
								{{ MeetingBasic.MeetingTitle }}
							</li>
							<li class="meetingInfo_lists_item">
								<div>{{ MeetingBasic.TimerSpan }}</div>
							</li>
							<li class="meetingInfo_lists_item">
								<div>
									{{ MeetingBasic.meetingaddress }}
								</div>
							</li>
						</ul>
					</div>
				</div>
				<div class="loading" v-if="loading">
					<van-loading type="spinner" color="#3b82f6" vertical size="30px" text-size="14px">加载中...
					</van-loading>
				</div>
				<div id="personalTicket" class="commonW" v-else v-for="(item, index) in UserListEntity" :key="index">
					<div class="personalTicket_container" v-if="ticketShow">
						<img v-if="item.SignupStatusCode === 1" src="../../assets/successful.png" alt />
						<img v-else-if="item.SignupStatusCode === 2" src="../../assets/unpaid.png" alt />
						<img v-else src="../../assets/awaitingAudit.png" alt />
						<div class="personalTicket_header">
							<span>{{ item.username }}</span>
							<div v-if="datas.signUp_Set.allow_update_info" @click="toModifyInfo(item.muid)">
								<van-icon name="edit" size="20px" />
							</div>
						</div>
						<div class="personalTicket_content">
							<div class="personalTicket_content_title">
								<span>{{ item.SignUpTypeName }}</span>
								<span v-if="item.SignUpMoney">¥ {{ item.SignUpMoney }}</span>
							</div>
							<div class="personalTicket_main" @click="toNext(item)">
								<div class="personalTicket_main_text">
									<p v-if="item.SignUpCaption!=null">{{ item.SignUpCaption }}</p>
									<div class="personalTicket_text_time" v-if="item.teamid>0">
										团队号：{{ item.teamid }}
									</div>
									<div class="personalTicket_text_time">
										报名时间：{{ item.createtime }}
									</div>
								</div>
								<van-icon name="arrow" />
							</div>
							<div class="live-data" v-if="islivedata ==  1">
								<div class="liveDiv">
									<p>直播观看时长</p>
									<p><span>{{ liveDatas.LiveTime}}</span> 分钟</p>
								</div>
								<div class="liveDiv" v-if="liveDatas.VodLiveTime!=0">
									<p>回放观看时长</p>
									<p><span>{{ liveDatas.VodLiveTime}}</span> 分钟</p>
								</div>
								<div class="liveDiv" v-if="liveDatas.CheckInCount!=0">
									<p>签到次数</p>
									<p><span>{{ liveDatas.CheckInCount}}</span> 次</p>
								</div>
							</div>

						</div>
						<p class="note" v-if="islivedata ==  1">该数据统计累计时长，数据统计稍有延迟</p>
					</div>
					<div class="personalTicket_footer">
						<div class="personalTicket_footer_zigzagImg">
							<img src="@assets/zigzag.png" alt />
						</div>
					</div>
				</div>
				<div id="orderInfo" v-if="ticketShow && orderEntityShow">
					<div class="orderInfo_container">
						<div class="orderInfo_ticketInfo">
							<ul>
								<li>
									<span>订单总价</span>
									<span>¥ {{ OrderEntity.paymoney }}</span>
								</li>
								<li>
									<span>实际支付金额</span>
									<span class="actualAmount">¥ {{ OrderEntity.realpaymoney }}</span>
								</li>
								<div class="pay-btns" v-if="OrderEntity.IsPay === 0">
									<div class="pay-btn" @click="goPay()">
										去支付
									</div>
								</div>
							</ul>
						</div>
						<div class="orderInfo_content">
							<ul>
								<li>
									<span>订单编号：</span>
									<span>{{ OrderEntity.orderid }}</span>
								</li>
								<li>
									<span>创建时间：</span>
									<span>{{ OrderEntity.createtime }}</span>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<div id="btn_list" class="commonW" v-if="!loading">
					<div class="btn_list_container">
						<ul v-if="datas.Code">
							<router-link class="btn_list_item"
								:to="{ path: '/signup/invoice', query: { m: params.m ,red: 'no' } }" tag="li"
								v-if="datas.signUp_Set.iswrite_invoice">
								<img src="@assets/invoicing.png" alt />
								<span>开发票</span>
							</router-link>
							<router-link class="btn_list_item"
								:to="{ path: '/signup/uploadProof', query: { m: params.m,red: 'no' } }" tag="li"
								v-if="datas.signUp_Set.upload_payorder">
								<img src="@assets/uploadCredentials.png" alt />
								<span>上传凭证</span>
							</router-link>
							<router-link class="btn_list_item" :to="{
                  path: '/signup/addPersonnel',
                  query: {
                    m: params.m,
                    teamid: UserListEntity[0].teamid,
                    ch: UserListEntity[0].chid,
                  },
                }" tag="li" v-if="datas.signUp_Set.is_multiuser">
								<img src="@assets/addPersonnel.png" alt />
								<span>添加人员</span>
							</router-link>
						</ul>
					</div>
				</div>
			</div>
		</div>

		<Footer v-if="footerShow" :footInfo="this.footInfo"></Footer>

	</div>
</template>
<script>
	import Footer from '@components/Footer'
	import Loading from '@components/Loading.vue'
	import publicSignup from '../../lib/signUp.js'
	export default {
		name: 'signUpInfo',
		components: {
			Loading,
			Footer,
		},
		data() {
			return {
				params: {
					m: '',
				},
				MeetingBasic: '',
				show: false,
				loading: false,
				publicTools: {}, //通用publicSignup

				datas: {}, //总数据
				UserListEntity: [], //处理后票据数据
				OrderEntity: '',
				orderEntityShow: true,

				ticketShow: false,

				footerShow: true,
				bannerList: [],
				liveDatas: '',
				islivedata: '',
				fNavShow: true,
				homeUrl: '',
				swiperOption: {
					observer: true,
					observeParents: true,
					loop: true,
					autoplay: {
						delay: 3000,
						stopOnLastSlide: false,
						disableOnInteraction: true,
					},
					pagination: {
						el: '.swiper-pagination',
						type: 'bullets'
					},
				},
				footInfo: {
					LogoTxt: '',
					LogoLink: '',
					LogoImg: '',
				},

			}
		},
		created() {
			//如果url含有'callpayback'，说明是微信支付后跳转过来的链接，需要给出弹框，重新跳回当前页面
			let _url = window.location.href
			if (_url.indexOf('callpayback') !== -1) {
				this.$dialog
					.confirm({
						message: '是否已完成支付',
						confirmButtonText: '已完成支付',
						cancelButtonText: '未完成支付',
						className: 'payDialog',
						width: '80%',
					})
					.then(() => {
						this.reloadUrl()
					})
					.catch(() => {
						this.reloadUrl()
					})
			} else {
				this.params = this.$route.query
				this.publicTools = new publicSignup()

				console.log(this.publicTools)
				// -----
				let opt = {
					m: this.params.m
				}
				this.init(opt)
				this.initmeeting()

			}
		},
		mounted() {
			//this.swiperInit()
		},
		methods: {
			swiperInit() {
				new window.Swiper('.signUpInfo-banner', { // eslint-disable-line no-unused-vars
					autoplay: {
						delay: 3000,
						stopOnLastSlide: false,
						disableOnInteraction: true,
					},
					pagination: {
						el: '.swiper-pagination',
					},
					observer: true,
					observeParents: true,
					loop: true,
				})
			},

			// 观看时长
			async initTime() {
				try {
					const params = {
						m: this.$route.query.m
					};
					const res = await this.$http.liveData(params);
					//console.log(res)
					this.liveDatas = res
				} catch (error) {
					console.error(error);
				}
			},
			/**
			 * 获取会议基本信息
			 */
			async initmeeting() {
				this.show = true

				let opt = {
					m: this.params.m,
					ch: this.$route.query.ch,
				}
				this.MeetingBasic = await this.publicTools.init(opt, this)
				this.footInfo.LogoTxt = this.MeetingBasic.LogoTxt
				this.footInfo.LogoLink = this.MeetingBasic.LogoLink
				this.footInfo.LogoImg = this.MeetingBasic.LogoImg
				this.bannerList = this.MeetingBasic.AdEntitys
				this.islivedata = this.MeetingBasic.islivedata
				this.$nextTick(function() {
					this.swiperInit()
				})
				// if (this.MeetingBasic.HomeUrl == null) {
				//   this.fNavShow = false
				// }else{
				//   this.homeUrl = this.MeetingBasic.HomeUrl
				// }
				this.$emit('homeFun', this.MeetingBasic.HomeUrl)
				this.$emit('logoFun', this.MeetingBasic.isshowlogo)
				this.$emit('meetinginfo',this.MeetingBasic)

				if (this.MeetingBasic.isshowlogo === 1) {
					this.footerShow = false
				}
				if (this.MeetingBasic.islivedata === 1) {
					this.initTime()
				}
				//sessionStorage.setItem("HomeUrl",this.MeetingBasic.HomeUrl)
				//sessionStorage.setItem("isshowlogo",this.MeetingBasic.isshowlogo)
				this.show = false
			},
			/**
			 * 初始化报名用户数据
			 */
			async init(opt) {
				try {
					this.loading = true
					let res = await this.$http.InitSignUpSetUserConfig(opt)

					//console.log('票据数据', res)
					if (res.Code === 1000) {
						let isSignPay = true
						this.datas = res
						this.UserListEntity = res.UserListEntity
						for (let i = 0; i < this.UserListEntity.length; i++) {
							if (this.UserListEntity[i].SignupStatusCode != 1) {
								isSignPay = false
							}
							let _time = this.UserListEntity[i].createtime
							let {
								year,
								month,
								day
							} = this.publicTools.changeFormDate(_time)
							this.UserListEntity[i].createtime =
								year + '年' + month + '月' + day + '日'
						}
						if (res.OrderEntity != null) {
							this.orderEntityShow = true
							this.OrderEntity = res.OrderEntity
							let _time = this.OrderEntity.createtime
							let {
								year,
								month,
								day
							} = this.publicTools.changeFormDate(_time)
							this.OrderEntity.createtime =
								year + '年' + month + '月' + day + '日'
						} else {
							this.orderEntityShow = false
						}
						// console.log('处理后票据数据', this.UserListEntity)
						let jump_link =
							this.$route.query.red == 'no' ? '' : res.signUp_Set.jump_link
						if (jump_link && isSignPay) {
							//this.loading = false
							this.show = true
							const {
								ch,
								channelId
							} = this.$route.query
							let _url = channelId !== undefined ? channelId : ch

							if (jump_link.indexOf('{channid}') !== -1) {
								jump_link = jump_link.replace('{channid}', _url)
							}
							if (jump_link.indexOf('userid') !== -1) {
								let _link = jump_link.replace('{userid}', res.CurrMuid)
								window.location.href = _link
							} else {
								window.location.href = jump_link
							}
						} else {
							this.ticketShow = true
							this.loading = false
						}
					} else {
						this.$notify({
							message: res.Msg,
							type: 'primary',
						})
					}
				} catch (err) {
					console.log(err)
				}
			},

			goPay() {
				this.$router.push({
					path: '/pay',
					query: this.$route.query,
				})
			},
			/**
			 * 点击每个用户的票据
			 */
			toNext(item) {
				if (item.SignupStatusCode === 2) {
					this.$router.push({
						path: '/pay',
						query: this.$route.query,
					})
				} else if (item.SignupStatusCode === 1) {
					let _HomeUrl = this.MeetingBasic.HomeUrl
					if (item.Red_Url != null && item.Red_Url != '') {
						window.location.href = item.Red_Url
					} else if (_HomeUrl) {
						window.location.href = _HomeUrl
					} else {
						// console.log('/signup/electronicticket')
						this.$router.push({
							path: '/signup/electronicticket',
							query: this.$route.query,
						})
					}
				} else {
					this.$notify({
						message: '等待审核中...',
						type: 'primary',
						duration: 3000,
					})
				}
			},
			/**
			 * 跳转当前页面并刷新
			 */
			reloadUrl() {
				this.$router.push({
					path: '/signup/signupinfo',
					query: {
						m: this.$route.query.m
					},
				})
				window.location.reload()
			},
			toModifyInfo(muid) {
				let _query = this.$route.query
				_query.muid = muid
				this.$router.push({
					path: '/signup/modifyInfo',
					query: _query,
				})
			},
		},
	}
</script>
<style lang="scss">
	.payDialog {
		.van-dialog__message {
			font-size: 32px;
			height: 100px;
			line-height: 100px;
		}

		.van-button {
			height: 100px;
			line-height: 100px;
		}

		.van-button__text {
			font-size: 32px;
		}

	}

	.swiper-pagination-bullet {
		width: 14px !important;
		height: 14px !important;
	}
</style>
<style lang="scss" scoped>
	.signUpInfo-banner,
	.signUpInfo-banners {
		width: 100%;
		overflow: hidden;
		position: relative;
	}

	.signUpInfo-banner .swiper-slide {
		position: relative;
		text-align: center;
	}

	.signUpInfo-banner img,
	.signUpInfo-banners img {
		max-width: 100%;
		display: block;
	}

	.commonW {
		width: 96%;
		margin: 0 auto;
	}

	// ----------
	#signUpInfo {
		.signUpInfo_container {
			padding-bottom: 100px;

			.live-data {
				border-top: 1px dashed #e2e8f0;
				display: flex;

				.liveDiv {
					flex: 1;
					text-align: center;
					padding: 20px 0;
					font-size: 26px;

					p {
						color: #1e293b;
						padding: 5px 0;
					}

					p:last-child span {
						font-size: 34px;
						color: #3b82f6;
						font-weight: bold;
					}
				}
			}

			.note {
				text-align: center;
				font-size: 22px;
				color: #64748b;
				margin-top: 20px;
			}

			.pay-btns {
				height: 60px;
				margin-top: 20px;
				border-top: 1px dashed #e2e8f0;
				padding-top: 20px;

				.pay-btn {
					background: #e6a23c;
					width: 200px;
					height: 60px;
					text-align: center;
					line-height: 60px;
					color: #fff;
					float: right;
					margin-right: 20px;
				}
			}

			.signUpInfo_content {
				.signUpInfo-banner {
					>img {
						width: 100%;
					}
				}

				#meeting_info {
					box-sizing: border-box;
					margin: 40px auto;
					margin-bottom: 60px;
					padding: 20px;
					background: #fff;
					box-shadow: 0 2px 12px rgba(0,0,0,0.04); border: 1px solid #e2e8f0;
					display: flex;

					.meetingInfo_img {
						width: 200px;
						height: 200px;
						margin-right: 44px;

						>img {
							width: 100%;
							height: 100%;
						}
					}

					.meetingInfo_content {
						flex: 1;
						font-size: 26px;
						margin-right: 34px;
						padding-top: 10px;
						box-sizing: border-box;

						.meetingInfo_content_lists {
							.meetingInfo_lists_item {
								line-height: 40px;
								color: #64748b;
								overflow: hidden;
								display: flex;

								&:first-child {
									color: #1e293b;
									margin-bottom: 10px;
								}

								>div:first-child {
									width: 80px;
								}

								>div:last-child {
									flex: 1;
								}
							}
						}
					}
				}

				#personalTicket {
					position: relative;
					margin-bottom: 30px;

					.personalTicket_container {
						margin: 0 auto;
						margin-top: -20px;
						border-bottom: 0;
						box-sizing: border-box;
						padding: 0 30px 30px;
						background: #fff;
						border: 2px solid #e2e8f0;
						border-bottom: 0;
						position: relative;

						>img {
							width: 17%;
							position: absolute;
							bottom: -10px;
							right: 0;
						}

						.personalTicket_header {
							height: 80px;
							line-height: 80px;
							font-size: 32px;
							color: #1e293b;
							border-bottom: 2px dashed #e2e8f0;
							display: flex;

							.van-icon {
								vertical-align: sub;
								margin-left: 10px;
							}
						}

						.personalTicket_content {
							border-bottom: 2px dashed #e2e8f0;

							.personalTicket_content_title {
								font-size: 32px;
								height: 60px;
								line-height: 60px;
								color: #1e293b;

								>span:last-child {
									font-size: 30px;
									color: #e6a23c;
								}
							}

							.personalTicket_main {
								position: relative;

								.personalTicket_main_text {
									width: 80%;
									font-size: 26px;
									color: #1e293b;

									.personalTicket_text_time {
										line-height: 60px;
										font-size: 24px;
										color: #64748b;
									}
								}

								>.van-icon {
									font-size: 40px;
									position: absolute;
									right: 0;
									top: -12%;
									color: #64748b;
								}
							}
						}
					}

					.personalTicket_footer {
						.personalTicket_footer_zigzagImg {
							margin: 0 auto;

							>img {
								width: 100%;
							}
						}
					}
				}

				#orderInfo {
					.orderInfo_container {
						font-size: 26px;
						color: #475569;

						line-height: 42px;

						.orderInfo_ticketInfo,
						.orderInfo_content {
							margin-bottom: 20px;
							background-color: #fff;
							padding: 20px 0;

							>ul {
								>li {
									width: 92%;
									margin: 0 auto;

									.actualAmount {
										color: #e6a23c;
									}
								}
							}
						}

						.orderInfo_ticketInfo {
							>ul {
								>li {
									display: flex;
									justify-content: space-between;
								}
							}
						}
					}
				}

				#btn_list {
					.btn_list_container {
						>ul {
							display: flex;
							flex-direction: row;
							font-size: 28px;

							.btn_list_item {
								margin-top: 30px;
								height: 80px;
								flex: 1;
								line-height: 80px;
								text-align: center;
								background: #fff;
								display: flex;
								justify-content: center;
								align-items: center;
								color: #475569;
								position: relative;

								&::after {
									content: '';
									display: block;
									width: 2px;
									height: 40%;
									background: #64748b;
									position: absolute;
									right: 0;
								}

								&:last-child {
									&::after {
										display: none;
									}
								}

								>img {
									width: 28px;
									height: 28px;
									margin-right: 10px;
								}
							}
						}
					}
				}
			}
		}

		.van-dialog {
			width: 70%;
			text-align: center;
			font-size: 32px;
			padding-top: 20px;

			.van-dialog__content {
				margin: 20px;
			}

			.van-button {
				font-size: 32px;
				line-height: 60px;
				height: 60px;
			}
		}
	}
</style>
